import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPosts } from "../utils/api";

export const fetchPosts = createAsyncThunk("posts/fetchPosts", async () => {
  return await getAllPosts();
});

const initialState = {
  posts: [],
  isLoading: false,
  error: null,
};

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    addPost: (state, action) => {
      state.posts.unshift(action.payload);
    },
    editPost: (state, action) => {
      const { _id, updatedContent } = action.payload;
      const post = state.posts.find((post) => post._id === _id);
      if (post) post.content = updatedContent;
    },
    likePost: (state, action) => {
      const { userId, postId } = action.payload;
      const post = state.posts.find((post) => post._id === postId);

      if (post) {
        if (post.likes.includes(userId)) {
          post.likes = post.likes.filter((id) => id !== userId);
        } else {
          post.likes.push(userId);
        }
      }
    },
    commentOnPost: (state, action) => {
      const { postId, userId, comment } = action.payload;
      const post = state.posts.find((post) => post._id === postId);
      if (post) {
        post.comments.push({ content: comment, commentUserId: userId });
      }
    },
    deletePostReducer: (state, action) => {
      state.posts = state.posts.filter(
        (post) => post._id !== action.payload.postId
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { addPost, deletePostReducer, editPost, likePost, commentOnPost } =
  postsSlice.actions;
export default postsSlice.reducer;
